import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Input } from 'antd';

const StyledCompoundUpdateName = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: space-between;

  .update-name_wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
  }

  .update-name_title {
    font-weight: bold;
    white-space: nowrap;
    margin-right: 10px;
  }
`;

const StyledInput = styled(({ isValid, ...props }) => <Input {...props} />)`
  outline: ${({ isValid }) => (isValid ? '' : 'solid red 1px')};
`;

const CompoundUpdateName = ({ name, onChange, showNotValidFields }) => {
  const [isValid, setValid] = useState(true);

  useEffect(() => {
    if (showNotValidFields) {
      setValid(!!name);
    }
  }, [name, showNotValidFields]);

  return (
    <StyledCompoundUpdateName>
      <div className="update-name_wrapper">
        <div className="update-name_title">Name:</div>
        <div>
          <StyledInput isValid={isValid} value={name} onChange={(e) => onChange(e.target.value)} />
        </div>
      </div>
    </StyledCompoundUpdateName>
  );
};

export default CompoundUpdateName;
